import { ModalAjaxError } from '../modal/index'

export function modal_ajax_error_handler (xhr, status, errorstr, body, title) {
    let modalBody;
    let modalTitle = title || 'Error';

    if (body) {
      modalBody = body;
    }
    else {
        try {
            modalBody = JSON.parse(xhr.responseText).message;
        } catch (error) {
            modalBody = 'Sorry, an error has occurred!';
        }
    }

    new ModalAjaxError({
        title: modalTitle,
        body: modalBody ,
        popup: true,
        url_parameters: {
            response: xhr.responseText,
            status: status,
            error: errorstr
        }
    }).show();
};



// WEBPACK FOOTER //
// ./assets/es6/modal/_ajax_error_handler.es6